import React from 'react'
import { Grid } from '@mui/material'
import FormikTextField from '../../../Formik/FormikTextField'
import InputAdornment from '@mui/material/InputAdornment'
import IconButton from '@mui/material/IconButton'
import Visibility from '@mui/icons-material/Visibility'
import VisibilityOff from '@mui/icons-material/VisibilityOff'
import Link from '@mui/material/Link'
import { useTranslation } from 'react-i18next'

interface SignInFormProps {
  onForgotPassword(e): void
}

const SignInFormFields: React.FC<SignInFormProps> = ({ onForgotPassword }) => {
  const { t } = useTranslation()
  const [showPassword, setShowPassword] = React.useState(false)
  return (
    <>
      <div className='fieldset'>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <FormikTextField name='username' label={t('formLabels.email', 'Email')} type='email' required />
          </Grid>
          <Grid item xs={12}>
            <FormikTextField
              name='password'
              label={t('formLabels.password', 'Password')}
              type={showPassword ? 'text' : 'password'}
              InputProps={{
                endAdornment: (
                  <InputAdornment position='end'>
                    <IconButton
                      aria-label='toggle password visibility'
                      onClick={() => {
                        setShowPassword(!showPassword)
                      }}
                      edge='end'
                    >
                      {!showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              required
            />
          </Grid>
        </Grid>
      </div>
      <p className='my-10'>
        <Link className='tracking-wide text-13 no-underline' onClick={onForgotPassword} color='secondary'>
          {t('forgotPassword', 'Forgot password?')}
        </Link>
      </p>
    </>
  )
}

export default SignInFormFields
